import React from "react";
import JobItem from "../List/JobItem";
import "../List/JobList.css";

export default function JobList({ jobs, activeJobId, onSelectJob }) {
  if (!jobs || jobs.length === 0) {
    return <div className="job-list no-jobs">Aucune offre disponible pour l'instant</div>;
  }

  return (
    <div className="job-list w-full md:w-1/3">
      {jobs.map((job) => (
        <JobItem
          key={job.id}
          title={job.title}
          location={job.location}
          contractType={job.contractType}
          active={activeJobId === job.id}
          onClick={() => onSelectJob(job.id)}
        />
      ))}
    </div>
  );
}
